
import XLSX from 'xlsx';

export default class ExcelService {

    makeExcelFromDeviceData(observationData, deviceId) {

        let currentDeviceObservationData = observationData[deviceId]
        let wsData = this.buildSheetDataArray(currentDeviceObservationData)
        let workSheet = XLSX.utils.aoa_to_sheet(wsData)

        workSheet = this.workSheetColumnWidths(workSheet, wsData)
        workSheet = this.setTimestampFormatFI(workSheet, currentDeviceObservationData)

        let workSheetName = deviceId;
        let workbook = XLSX.utils.book_new()

        XLSX.utils.book_append_sheet(workbook, workSheet, workSheetName);
        let workBookName = deviceId + '.xlsx'
        XLSX.writeFile(workbook, workBookName)
    }

    buildSheetDataArray(observationData) {
        let wsData = []

        wsData.push([])
        wsData[0].push('Aikaleima')
        for (let i = 0; i < observationData.length; i++) {
            wsData[0].push(observationData[i].variable)
        }

        for (let line = 0; line < observationData[0].observations.length; line++) {
            wsData.push([])
            let timestamp = new Date(observationData[0].observations[line].time)

            wsData[line + 1].push(timestamp)
            for (let j = 0; j < wsData[0].length - 1; j++) {
                wsData[line + 1].push(observationData[j].observations[line].value)
            }
        }

        return wsData
    }

    setTimestampFormatFI(workSheet, observationData) {
        for (let line = 0; line < observationData[0].observations.length; line++) {
            let cell = workSheet['A' + (line + 2)]
            delete cell.w
            cell.z = 'd.m.yyyy hh:mm'
        }

        workSheet['!cols'][0] = {wch: 13}

        return workSheet
    }

    workSheetColumnWidths(workSheet, wsData) {

        workSheet['!cols'] = []
        for (let i = 0; i < wsData[0].length; i++) {
            workSheet['!cols'].push({wch: wsData[0][i].toString().length})
        }

        return workSheet
    }
}


// WEBPACK FOOTER //
// ./src/app/service/ExcelService.js